import { render, staticRenderFns } from "./Input-Name.vue?vue&type=template&id=263e54a6&lang=pug"
import script from "./Input-Name.vue?vue&type=script&lang=ts"
export * from "./Input-Name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports